import React, { useState, useEffect, useCallback, useRef } from 'react';
import MyButton from 'components/ui/Button/MyButton';
import { Input, Card, Spin, Switch, Button } from 'antd'
import ToastMsg from "components/common/ToastMsg";
import useGetData from "components/common/useGetData";
import { getTdsConfiguration } from "hooks/api/configurationApi/payrollPeriodApi";
import { checkUserPermissionFunc } from "components/common/CommonFuntion";
import "../configuration.css";
import { TDS_CONFIGURATION } from 'constants';
import { handleOnKeyDecimal, handleOnKeyDecimalValues, handleOnKeyNumeric, handleOnKeyNumericDecimal } from 'components/common/validation';
import { CheckCircleTwoTone, DeleteTwoTone, EditTwoTone, PlusCircleOutlined } from '@ant-design/icons';

const TDSConfiguration = () => {
    const [formData, setFormData] = useState({
        old_regime: {
            standard_deduction: null,
            rebate_limit: null,
            rebate_amount: null,
            from_year: null,
            to_year: null,
            slab_configurations: [
                {
                    min_amount: 0,
                    max_amount: 250000,
                    percentage: 0,
                    text_field: false,
                }
            ]
        },
        new_regime: {
            standard_deduction: null,
            rebate_limit: null,
            rebate_amount: null,
            from_year: null,
            to_year: null,
            slab_configurations: [
                {
                    min_amount: 0,
                    max_amount: 250000,
                    percentage: 0,
                    text_field: false,
                },
            ]
        },
        cess_percentage: null,
        test: "55",
    });
    const [Declaration, setDeclaration] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const prevPropsRef = useRef();
    const refs = useRef({});

    const [sltTooltipState, setsltTooltipState] = useState({
        showTooltip: false,
        tooltipPosition: { x: 0, y: 0 },
        omittedValues: []
    });
    const [data, _message, refetch, loading] = useGetData(getTdsConfiguration);
    const userPermission = checkUserPermissionFunc("configuration", "Custom Configuration", "SubMenu")

    useEffect(() => {
        if (data !== null &&
            JSON.stringify(prevPropsRef.current) !== JSON.stringify(data) &&
            JSON.stringify(formData) !== JSON.stringify(data)) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                new_regime_id: data?.new_regime_id ? data?.new_regime_id : undefined,
                old_regime_id: data?.old_regime_id ? data?.old_regime_id : undefined,
                cess_percentage: data?.cess_percentage ? data?.cess_percentage : 0,
                new_regime: {
                    rebate_amount: data?.new_regime?.rebate_amount ? data?.new_regime?.rebate_amount : 0,
                    rebate_limit: data?.new_regime?.rebate_limit ? data?.new_regime?.rebate_limit : 0,
                    standard_deduction: data?.new_regime?.standard_deduction ? data?.new_regime?.standard_deduction : 0,
                    from_year: data?.new_regime?.from_year ? data?.new_regime?.from_year : "",
                    to_year: data?.new_regime?.to_year ? data?.new_regime?.to_year : "",
                    slab_configurations: data?.new_regime?.slab_configurations.length > 0 ? data?.new_regime?.slab_configurations : prevFormData?.new_regime?.slab_configurations
                },
                old_regime: {
                    rebate_amount: data?.old_regime?.rebate_amount ? data?.old_regime?.rebate_amount : 0,
                    rebate_limit: data?.old_regime?.rebate_limit ? data?.old_regime?.rebate_limit : 0,
                    standard_deduction: data?.old_regime?.standard_deduction ? data?.old_regime?.standard_deduction : 0,
                    from_year: data?.old_regime?.from_year ? data?.old_regime?.from_year : "",
                    to_year: data?.old_regime?.to_year ? data?.old_regime?.to_year : "",
                    slab_configurations: data?.old_regime?.slab_configurations.length > 0 ? data?.old_regime?.slab_configurations : prevFormData?.old_regime?.slab_configurations
                },
            }));
            prevPropsRef.current = data;
            setDeclaration({
                Declaration: data?.tds_available === true ? true : false
            })
        }
    }, [data]);

    const onChange = (stateKey, value, tds) => {
        setFormData((prevState) => {
            if (tds === "old") {
                return {
                    ...prevState,
                    old_regime: {
                        ...prevState.old_regime,
                        [stateKey]: value,
                    },
                };
            } else if (tds === "new") {
                return {
                    ...prevState,
                    new_regime: {
                        ...prevState.new_regime,
                        [stateKey]: value,
                    },
                };
            } else {
                return {
                    ...prevState,
                    [stateKey]: parseFloat(value),
                };
            }
        });
    };

    const onChangeTds = (stateKey, value, index, key) => {
        setFormData((prevData) => {
            const updatedArray = [...prevData[key].slab_configurations];
            updatedArray[index] = {
                ...updatedArray[index],
                [stateKey]: value,
            };
            return {
                ...prevData,
                [key]: {
                    ...prevData[key],
                    slab_configurations: updatedArray,
                },
            };
        });
    };

    const handleToggleTooltip = (visible, values, position) => {
        setsltTooltipState((prevState) => ({
            ...prevState,
            showTooltip: visible,
            tooltipPosition: position,
            omittedValues: values
        }))
    };

    const handleMouseEnter = (event, omittedValues) => {
        const rect = event.target.getBoundingClientRect();
        handleToggleTooltip(true, omittedValues, { x: rect.left, y: rect.bottom });
    };

    const handleMouseLeave = () => {
        handleToggleTooltip(false, [], { x: 0, y: 0 });
    };

    const renderMaxTagPlaceholder = (omittedValues) => (
        <div
            onMouseEnter={(event) => handleMouseEnter(event, omittedValues)}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer' }}
        >
            +{omittedValues.length}
        </div>
    );

    const renderInputs = (inputType = "", statekeyList, labelList, tds = "") => {
        return (
            <div className='flex items-center gap-3'>
                {
                    statekeyList?.map((item, index) => {
                        return (
                            <div className='flex items-center' key={item}>
                                <p className='custom_config_sub_txt'>{labelList[index]}</p>
                                <Input
                                    className='ml-3'
                                    style={styles.border_input}
                                    disabled={!userPermission?.edit}
                                    name={item}
                                    bordered={true}
                                    prefix={inputType === "percentage" ? "%" : inputType === "amount" ? "₹" : null}
                                    type={"text"}
                                    autoComplete='off'
                                    maxLength={inputType === "percentage" ? 5 : inputType === "amount" ? 7 : 50}
                                    value={tds === "old" ? formData?.old_regime?.[item] : tds === "new" ? formData?.new_regime?.[item] : formData[item]}
                                    onChange={(e) => onChange(item, (inputType === "percentage" || inputType === "amount") ? +e.target.value : e.target.value, tds)}
                                    onKeyDown={inputType === "percentage" ? handleOnKeyDecimal : inputType === "amount" ? handleOnKeyNumeric : null}
                                />
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    const renderinputPercent = (inputType = "", statekey, index, key) => {
        return (
            <Input
                className='ml-3'
                style={styles.border_input}
                disabled={!userPermission?.edit || statekey === "min_amount" ? true : false}
                name={statekey}
                bordered={true}
                prefix={inputType === "percentage" ? "%" : inputType === "amount" ? "₹" : null}
                type={"text"}
                autoComplete='off'
                maxLength={inputType === "percentage" ? 5 : inputType === "amount" ? 7 : 50}
                value={formData[key]?.slab_configurations?.[index]?.[statekey] || ""}
                onChange={(e) => onChangeTds(statekey, (inputType === "percentage" || inputType === "amount") ? +e.target.value : e.target.value, index, key)}
                onKeyDown={inputType === "percentage" ? handleOnKeyDecimal : inputType === "amount" ? handleOnKeyNumeric : null}
            />
        )
    }

    const renderConfigOptions = (label, stateKey, inputType, inputList = [], labelList = [], notes = "", tds = "") => {
        return (
            <div className='w-full flex justify-between items-center my-2' style={{ height: "8dvh" }}>
                <p className='custom_config_sub_txt' >{label}</p>
                <div className='flex flex-col justify-end' >
                    {
                        inputType === "renderInputs" ? renderInputs(stateKey, inputList, labelList, tds)
                            : null
                    }
                    {notes ? <p className='custom_config_note_txt'>{`Note: ${notes}`}</p> : null}
                </div>
            </div>
        );
    }

    const validateVal = () => {
        const missingFields = [];

        // Check for missing values
        if (!formData?.cess_percentage && formData?.cess_percentage !== 0) missingFields.push("Cess Percentage");
        if (!formData?.old_regime?.standard_deduction && formData?.old_regime?.standard_deduction !== 0) missingFields.push("Old Regime Standard Deduction");
        if (!formData?.new_regime?.standard_deduction && formData?.new_regime?.standard_deduction !== 0) missingFields.push("New Regime Standard Deduction");
        if (!formData?.old_regime?.rebate_limit && formData?.old_regime?.rebate_limit !== 0) missingFields.push("Old Regime Rebate Limit");
        if (!formData?.new_regime?.rebate_limit && formData?.new_regime?.rebate_limit !== 0) missingFields.push("New Regime Rebate Limit");
        if (!formData?.old_regime?.rebate_amount && formData?.old_regime?.rebate_amount !== 0) missingFields.push("Old Regime Rebate Amount");
        if (!formData?.new_regime?.rebate_amount && formData?.new_regime?.rebate_amount !== 0) missingFields.push("New Regime Rebate Amount");

        // Function to check slab_configurations
        const validateSlabConfigurations = (regime, regimeName) => {
            regime.slab_configurations.forEach((slab, index) => {
                if (slab.text_field) {
                    if (slab.percentage == null && index != 0) {
                        missingFields.push(`${regimeName} Slab ${index + 1} (Incomplete fields for percentage)`);
                    }
                } else{
                    missingFields.push("In complete fields values");
                }
            });
        };

        // Validate both old and new regime slab configurations
        validateSlabConfigurations(formData.old_regime, "Old Regime");
        validateSlabConfigurations(formData.new_regime, "New Regime");

        // If missing fields exist, return a formatted error message
        if (missingFields.length > 0) {
            return `Kindly enter valid data for: ${missingFields.join(", ")}.`;
        }

        return ""; // No errors
    };

    const handleChange = (checked) => {
        setDeclaration(checked);
    };

    const handleSucces = (dataKey, index, value) => {
        const lastRow = formData[dataKey]?.slab_configurations[index];
        const lastMinAmount = lastRow?.min_amount || null;
        const lastMaxAmount = lastRow?.max_amount || null;
        if (lastMaxAmount >= lastMinAmount || lastMaxAmount == null) {
            setFormData((prevData) => {
                const updatedArray = [...prevData[dataKey]["slab_configurations"]];

                // Update the specific item's "text_field" value
                updatedArray[index]["text_field"] = value;
                return {
                    ...prevData,
                    [dataKey]: {
                        ...prevData[dataKey],
                        slab_configurations: updatedArray
                    }
                };
            });
        }
        else {
            ToastMsg("error", "Max amount cannot be less than Min amount.");
        }
    }


    // Function to dynamically add a new slab
    const handleAdd = (key) => {
        const allPreviousFieldsFilled = formData[key]?.slab_configurations.every((item, index) => {
            if (index !== 0) {
                return item.min_amount && item.max_amount && item.percentage && item.text_field;
            }
            else if (item.text_field) {
                return true;
            }
            return false;
        });

        if (allPreviousFieldsFilled) {
            // Get the last row values for min_amount and max_amount
            const slabConfigurations = formData[key]?.slab_configurations;
            const lastRow = slabConfigurations[slabConfigurations.length - 1];
            const lastMinAmount = lastRow?.min_amount || null;
            const lastMaxAmount = lastRow?.max_amount || null;
            if (lastMaxAmount >= lastMinAmount) {
                const newItems = [
                    ...formData[key].slab_configurations,
                    { min_amount: lastMaxAmount || null, max_amount: null, percentage: null }
                ];
                setFormData((prevData) => ({
                    ...prevData,
                    [key]: {
                        ...prevData[key],
                        slab_configurations: newItems
                    }
                }));
            }
            else {
                ToastMsg("error", "Max amount cannot be less than Min amount.");
            }
        } else {
            ToastMsg("error", "Please fill in all the previous fields before adding a new one.");
        }
    };

    // Function to delete a specific slab
    const handleDelete = (key, index) => {
        setFormData((prevData) => {
            const updatedArray = prevData[key].slab_configurations.filter((_, i) => i !== index);
            return {
                ...prevData,
                [key]: {
                    ...prevData[key],
                    slab_configurations: updatedArray
                }
            };
        });
    };

    const renderIncomeFields = (dataKey) => {
        return formData?.[dataKey]?.slab_configurations?.map((item, index, array) => {
            const isLastIndex = index === array.length - 1; // Check if it's the last index

            return (
                <div key={`${dataKey}-${index}`} className="mt-5">
                    <div className="flex justify-between">
                        <span>
                            {!item?.text_field ? (
                                <>
                                    <span className="w-10">Rs</span>
                                    {renderinputPercent("amount", "min_amount", index, dataKey)}
                                    <span className="ml-2">To</span>
                                    {renderinputPercent("amount", "max_amount", index, dataKey)}
                                    {/* <span className="ml-2">Lakhs</span> */}
                                </>
                            ) : (
                                <span>
                                    Rs <span style={{ width: "4dvw", display: "inline-block" }}>{item?.min_amount}</span>
                                    To <span style={{ width: "4dvw", display: "inline-block", alignItems: "end" }}>{item?.max_amount}</span>
                                </span>
                            )}

                            {isLastIndex && ( // Show Edit and Delete buttons only for the last index
                                <>
                                    {!item?.text_field ? (
                                        <Button
                                            onClick={() => handleSucces(dataKey, index, true)}
                                            icon={<CheckCircleTwoTone twoToneColor="#24ce04" className="notifyIcon" />}
                                            style={{ border: 0 }}
                                            size="large"
                                            disabled={false}
                                            className='ml-3'
                                        />
                                    ) : (
                                        <Button
                                            onClick={() => handleSucces(dataKey, index, false)}
                                            icon={<EditTwoTone twoToneColor="blue" className="notifyIcon" />}
                                            style={{ border: 0 }}
                                            size="large"
                                            disabled={false}
                                            className='ml-3'
                                        />
                                    )}
                                    {index != 0 &&
                                        <Button
                                            onClick={() => handleDelete(dataKey, index)}
                                            icon={<DeleteTwoTone twoToneColor="red" className="notifyIcon" />}
                                            style={{ border: 0 }}
                                            size="large"
                                            disabled={false}
                                            className=''
                                        />
                                    }

                                </>
                            )}
                        </span>
                        <span>
                            {renderinputPercent("percentage", "percentage", index, dataKey)}
                        </span>
                    </div>
                </div>
            );
        });
    };

    const handleSubmit = useCallback(() => {
        const authtoken = sessionStorage.getItem("token");
        let isValid = validateVal();
        if (isValid === "") {
            let updateFormData = { ...formData };
            updateFormData = {
                ...updateFormData,
                zero_payroll: updateFormData?.zero_payroll === 'yes' ? true : false,
            }
            try {
                setLoadings(true)
                fetch(TDS_CONFIGURATION, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `token ${authtoken}`
                    },
                    body: JSON.stringify(updateFormData)
                })
                    .then((response) => response.json())
                    .then(async data => {
                        if (data?.status === "success") {
                            setLoadings(false);
                            refetch();
                            ToastMsg("success", data?.message);
                        }
                        else if (data?.status === "fail") {
                            ToastMsg("error", data?.message);
                            setLoadings(false);
                        }
                    })
                    .catch(error => {
                        setLoadings(false);
                        ToastMsg("error", error);
                    });
            } catch (error) {
                ToastMsg("error", error?.message);
            }
        } else {
            ToastMsg("error", isValid);
        }
    }, [formData]);

    return (
        <Card style={{ height: "100%", overflow: "hidden", position: "relative" }}>
            {loading && (
                <div className="loaderOverlay">
                    <Spin />
                </div>
            )}
            <p className='runpayRoll_Txt border-b py-1'>TDS Configuration</p>
            <div style={{ height: "79dvh" }}>
                <div className='overflow-y-auto' style={{ height: "74dvh", paddingRight: ".5dvw" }}>
                    <p className='rostering_Txt py-1'>Allow TDS deduction
                        <span style={{ float: "inline-end" }}>
                            <label className="common_employee_nameTxt" style={{ fontSize: ".85vw" }}>No</label>
                            <Switch className="custom-switch" style={{ border: "1px solid #04b7b1" }} disabled ={true} checked={Declaration} onChange={handleChange} />
                            <label className="common_employee_nameTxt" style={{ fontSize: ".85vw" }}>Yes</label>
                        </span></p>
                    {Declaration && <>
                        <p className='pla_desTxt py-1'>OLD REGIME INCOME</p>
                        {renderIncomeFields("old_regime")}
                        <div className="flex flex-row justify-start border-b">
                            <Button
                                onClick={() => handleAdd("old_regime")}
                                icon={<PlusCircleOutlined className="plusIcon" />}
                                style={{ border: 0 }}
                                size="large"
                                disabled={false}
                            >Add</Button>
                        </div>
                        <p className='pla_desTxt py-1'>NEW REGIME INCOME</p>
                        {renderIncomeFields("new_regime")}
                        <div className="flex flex-row justify-start">
                            <Button
                                onClick={() => handleAdd("new_regime")}
                                icon={<PlusCircleOutlined className="plusIcon" />}
                                style={{ border: 0 }}
                                size="large"
                                disabled={false}
                            >Add</Button>
                        </div>
                        {renderConfigOptions("New Regime is year based configuration (1/year) (Period - 1st April to 31st March)", "", "")}
                        {renderConfigOptions("Standard Amount for Old Regime", "amount", "renderInputs", ["standard_deduction"], [], "", "old")}
                        {renderConfigOptions("Standard Amount for New Regime", "amount", "renderInputs", ["standard_deduction"], [], "", "new")}
                        {renderConfigOptions("Tax Rebate for Old Regime Amount", "amount", "renderInputs", ["rebate_amount"], [], "", "old")}
                        {renderConfigOptions("Tax Rebate for New Regime Amount", "amount", "renderInputs", ["rebate_amount"], [], "", "new")}
                        {renderConfigOptions("Tax Rebate for Old Regime Limit", "amount", "renderInputs", ["rebate_limit"], [], "", "old")}
                        {renderConfigOptions("Tax Rebate for New Regime Limit", "amount", "renderInputs", ["rebate_limit"], [], "", "new")}
                        {renderConfigOptions("Health & Education CESS Percentage Config in TDS Configuration also added in the same screen", "percentage", "renderInputs", ["cess_percentage"])}
                    </>}
                </div>
                <div className="w-full flex justify-center items-start" style={{ height: "7dvh" }}>
                    <MyButton htmlType="submit" disabled={!userPermission?.edit}
                        bgColor={userPermission?.edit ? "#334B49" : "#cbcbcb"}
                        onClick={handleSubmit} label={"Save"}
                        loading={loadings} paddingX={"0 1.2vw"}
                        marginRight={"0.625vw"} />
                </div>
            </div>
        </Card>
    );
}

const styles = {
    border_input: {
        width: "8dvw",
        borderRadius: "0px",
        border: "1px solid #CACACA",
        paddingLeft: "5px"
    },
    border_select: {
        width: "18dvw",
        borderRadius: "0px",
        border: "1px solid #CACACA",
    }
}

export default TDSConfiguration;